module.exports = __webpack_public_path__ + "static/media/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.52.1ddcee8c.png";